const PORTAL_CONTAINER_ID = "__portal-container";

export const getDefaultContainer = () => {
  const rootNode = document.getElementById(PORTAL_CONTAINER_ID);

  if (rootNode) {
    return rootNode;
  }

  const container = document.createElement("div");

  container.setAttribute("id", PORTAL_CONTAINER_ID);

  document.body.appendChild(container);

  return container;
};
